export enum LicensingItemType {
  License = 'License',
  SKU = 'SKU',
  User = 'User'
}
